/**
 * Theme deferred scripts: Searchanise helpers, Klaviyo loader, accessibility.
 * Loaded with defer so initial HTML parse and TBT are reduced.
 */
(function() {
  var isCollection = document.body.classList.contains('template-collection') || document.body.classList.contains('template-search');

  /* Searchanise custom logic – only on collection/search */
  if (isCollection) {
    var collectionAd = null;
    function captureCollectionAd() {
      var el = document.querySelector('.col_ad_box');
      if (el && el.parentNode) {
        collectionAd = el;
        el.parentNode.removeChild(el);
      }
    }
    function doTagWork(container) {
      if (!container) return;
      var run = function() {
        var lastPage = document.querySelector('.snize-collection-mode .snize-pagination ul > li:nth-last-child(2) a');
        var activePage = document.querySelector('.snize-collection-mode .snize-pagination ul > li a.active');
        var lastRev = lastPage ? lastPage.getAttribute('rev') : null;
        var activeRev = activePage ? activePage.getAttribute('rev') : null;
        var relColl = document.querySelector('.cst_relvant_coll');
        if (relColl && lastRev === activeRev) relColl.style.display = '';
        var target = document.querySelector('.snize-collection-mode .snize-search-results-content > li:nth-child(11)');
        if (collectionAd && target) {
          if (target.nextSibling) target.parentNode.insertBefore(collectionAd, target.nextSibling);
          else target.parentNode.appendChild(collectionAd);
        }
        var products = container.querySelectorAll('.snize-product');
        for (var i = 0; i < products.length; i++) {
          var p = products[i];
          var discounted = p.querySelector('.snize-discounted-price');
          var priceList = p.querySelector('.snize-price-list');
          if (priceList) {
            if (discounted) priceList.classList.remove('no_discount_class');
            else priceList.classList.add('no_discount_class');
          }
          var mainP = p.querySelector('.snize-price');
          var compP = p.querySelector('.snize-discounted-price');
          if (mainP && compP && priceList) {
            var mainVal = parseFloat((mainP.textContent || '').replace(/[^0-9.]/g, '')) || 0;
            var compVal = parseFloat((compP.textContent || '').replace(/[^0-9.]/g, '')) || 0;
            var save = compVal - mainVal;
            if (!isNaN(save)) priceList.setAttribute('data-price', 'Save $' + save.toFixed(2));
          }
        }
      };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 500 });
      else setTimeout(run, 0);
    }
    var scheduled = false;
    function onResultsUpdate() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function() {
        scheduled = false;
        var container = document.getElementById('snize_results');
        if (container && container.querySelector('.snize-product')) doTagWork(container);
      });
    }
    document.addEventListener('Searchanise.ResultsUpdated', function(ev) {
      var raw = (ev.detail && ev.detail[0]) || ev.target;
      var container = (raw && (raw.nodeType === 1 ? raw : raw[0])) || document.getElementById('snize_results');
      doTagWork(container);
    });
    var snize = document.getElementById('snize_results');
    if (snize) {
      var mo = new MutationObserver(onResultsUpdate);
      mo.observe(snize, { childList: true, subtree: true });
    }
    setTimeout(function() {
      var c = document.getElementById('snize_results');
      if (c && c.querySelector('.snize-product')) doTagWork(c);
    }, 2500);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', captureCollectionAd);
    } else {
      captureCollectionAd();
    }
  }

  /* Klaviyo: load on first interaction or after 5s */
  (function loadKlaviyo() {
    function run() {
      if (window.__klaviyoLoaded) return;
      window.__klaviyoLoaded = true;
      var kl = document.createElement('script');
      kl.async = true;
      kl.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
      kl.onload = function() {
        window.klaviyo = window.klaviyo || [];
        klaviyo.init({ account: 'WSNfsu', platform: 'shopify' });
        klaviyo.enable('backinstock');
      };
      document.body.appendChild(kl);
    }
    var t = setTimeout(run, 5000);
    function onInteraction() {
      clearTimeout(t);
      run();
      document.removeEventListener('scroll', onInteraction, { passive: true });
      document.removeEventListener('click', onInteraction);
      document.removeEventListener('keydown', onInteraction);
    }
    document.addEventListener('scroll', onInteraction, { passive: true });
    document.addEventListener('click', onInteraction);
    document.addEventListener('keydown', onInteraction);
  })();

  /* Accessibility: title for Google Merchant iframe */
  (function() {
    var observer = new MutationObserver(function(mutations, obs) {
      var iframe = document.getElementById('merchantwidgetiframe');
      if (iframe) {
        iframe.setAttribute('title', 'Google Merchant Trusted Store Widget');
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  /* Collection: clean page=1 URL and wrap history */
  if (isCollection) {
    function cleanCollectionPage1Url() {
      if (!window.location.pathname.startsWith('/collections/')) return;
      var params = new URLSearchParams(window.location.search);
      if (params.get('page') === '1') {
        var cleanUrl = window.location.pathname;
        if (window.location.href !== window.location.origin + cleanUrl) {
          history.replaceState(history.state, '', cleanUrl);
        }
      }
    }
    function wrapHistory(method) {
      var orig = history[method];
      history[method] = function(state, title, url) {
        if (url && url.indexOf('page=1') !== -1) {
          try {
            var base = window.location.origin + window.location.pathname;
            var u = new URL(url, base);
            var p = new URLSearchParams(u.search);
            if (p.get('page') === '1') url = u.pathname;
          } catch (e) {}
        }
        return orig.call(this, state, title, url);
      };
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        cleanCollectionPage1Url();
        wrapHistory('pushState');
        wrapHistory('replaceState');
      });
    } else {
      cleanCollectionPage1Url();
      wrapHistory('pushState');
      wrapHistory('replaceState');
    }
  }
})();
